export function getdata() {
	var obj = {
		
			headDataI:[
				{
					title:'项目',
					children:[
						{
							prop:'title_one',
							width: "150px",
							custom: true,
						},
						{
							prop:'title_two',
							width: "150px",
							custom: true,
						},
						{
							prop:'title_three',
							width: "150px",
							custom: true,
						}
					]
					
				},
				{
					title: "栏  次",
					custom: true,
					prop: "grade",
					width: "200px",
				}, {
					title: "本月（期）数",
					custom: true,
					prop: "whsy_0_x_1",
					width: "200px",
				
				},{
					title: "*本年累计",
					custom: true,
					prop: "whsy_0_x_2",
					width: "200px",
				}
			],
			tableDataII:{
				whsy_sfdlsb:'1',
				whsyjn_jbr:{
					disablewhsyjn_jbr:false,
					whsyjn_jbr:{
						cellCode:"whsyjn_jbr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsyjn_fddbr:{
					disablewhsyjn_fddbr:false,
					whsyjn_fddbr:{
						cellCode:"whsyjn_fddbr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsyjn_cwfzr:{
					disablewhsyjn_cwfzr:false,
					whsyjn_cwfzr:{
						cellCode:"whsyjn_cwfzr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsyjn_lxdh:{
					disablewhsyjn_lxdh:false,
					whsyjn_lxdh:{
						cellCode:"whsyjn_lxdh",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsydl_dlrmc:{
					disablewhsydl_dlrmc:false,
					whsydl_dlrmc:{
						cellCode:"whsydl_dlrmc",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsydl_sfzlx:{
					disablewhsydl_sfzlx:false,
					whsydl_sfzlx:{
						cellCode:"whsydl_sfzlx",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsydl_dlr:{
					disablewhsydl_dlr:false,
					whsydl_dlr:{
						cellCode:"whsydl_dlr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsydl_jbr:{
					disablewhsydl_jbr:false,
					whsydl_jbr:{
						cellCode:"whsydl_jbr",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsydl_sfzhm:{
					disablewhsydl_sfzhm:false,
					whsydl_sfzhm:{
						cellCode:"whsydl_sfzhm",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
				whsydl_lxdh:{
					disablewhsydl_lxdh:false,
					whsydl_lxdh:{
						cellCode:"whsydl_lxdh",
						cellType:"1",
						cellVal:"240040043.08"
					}
				},
			},
			tableDataI:[
				{
						title_two:'计费收入',
						title_three:'应征收入',
						grade:'1',
						disabledwhsy_0_x_1:false,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},
					{
						title_two:'计费收入',
						title_three:'免征收入',
						grade:'2',
						disabledwhsy_0_x_1:false,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_three:'减除项目期初金额',
						grade:'3',
						disabledwhsy_0_x_1:false,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_three:'减除项目本期发生额',
						grade:'4',
						disabledwhsy_0_x_1:false,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_two:'本期减除额',
						title_three:'应征收入减除额',
						grade:'5',
						disabledwhsy_0_x_1:false,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_two:'本期减除额',
						title_three:'免征收入减除额',
						grade:'6',
						disabledwhsy_0_x_1:false,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_three:'减除项目期末余额',
						grade:'7',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_three:'计费销售额',
						grade:'8',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_three:'费率',
						grade:'9',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额计算',
						title_three:'应缴费额',
						grade:'10',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'期初未缴费额（多缴为负）',
						grade:'11',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'本期已缴费额',
						grade:'12',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:' 其中：本期预缴费额',
						grade:'13',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'本期缴纳上期费额',
						grade:'14',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'本期缴纳欠费额',
						grade:'15',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'期末未缴费额（多缴为负）',
						grade:'16',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'其中：欠缴费额（>=0）',
						grade:'17',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'本期应补（退）费额',
						grade:'18',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					},{
						title_one:'费额缴纳',
						title_three:'本期检查已补缴费额',
						grade:'19',
						disabledwhsy_0_x_1:true,
						disabledwhsy_0_x_2:false,
						whsy_0_x_1: {
							cellCode:"whsy_0_x_1",
							cellType:"1",
							cellVal:"240040043.08"
						},
						whsy_0_x_2: {
							cellCode:"whsy_0_x_2",
							cellType:"1",
							cellVal:"240040043.08"
						},
					}
			],
		
	}
	return obj
}
